import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL, // Fixed: removed "Search" from the end
  timeout: 10000,
});

export const search = async (query, category, filters = {}, page = 1, limit = 12) => {
  try {
    const response = await api.post('/search', {
      query,
      category,
      filters
    }, {
      params: { page, limit }
    });

    return {
      success: true,
      data: response.data.data,
      pagination: response.data.pagination,
      parsed: response.data.parsed
    };
  } catch (error) {
    console.error('Search API error:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Search failed'
    };
  }
};

export const getSearchFilters = async () => {
  try {
    const response = await api.get('/search/filters');
    return {
      success: true,
      data: response.data.data
    };
  } catch (error) {
    console.error('Get filters API error:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Failed to get filters'
    };
  }
};